import { routes } from '@/pages'
import { Button } from '@/ui-kit'
import { Link } from '@/ui-kit/components/Link'
import { Trans, useLingui } from '@lingui/react/macro'
import { Mission } from '../api/models'
import { BUTTON_TEXT_MAP } from './MissionBadge'

export const MissionCardMainActionButton = ({ mission }: { mission: Mission }) => {
  const { t } = useLingui()
  const variant =
    mission.status !== 'ENDED' && mission.availability?.available && mission.view.nextSubmissionAvailable
      ? 'bordered'
      : 'secondary'
  const isDisabled =
    mission.view.latestSubmissionStatus === 'SUBMITTED' ||
    (!mission.view.nextSubmissionAvailable && mission.view.latestSubmissionStatus === 'FAILED')
  const buttonText =
    mission.status !== 'ENDED' && mission.availability?.available ? (
      <>
        {mission.view.latestSubmissionStatus === 'COMPLETED' && mission.view.nextSubmissionAvailable
          ? t(BUTTON_TEXT_MAP.COMPLETED)
          : mission.view.nextSubmissionAvailable
            ? t(BUTTON_TEXT_MAP.null)
            : t(BUTTON_TEXT_MAP[mission.view.latestSubmissionStatus ?? 'null'] ?? BUTTON_TEXT_MAP.null)}
      </>
    ) : (
      <>
        <Trans>Continue</Trans>
      </>
    )

  return mission.type === 'STAKING' ? (
    <Link href={routes.stake.path} className="w-full" variant={variant} size="small" disabled={isDisabled}>
      {buttonText}
    </Link>
  ) : (
    <Button className="w-full" variant={variant} size="small" isDisabled={isDisabled}>
      {buttonText}
    </Button>
  )
}
